import { render, staticRenderFns } from "./file-dropzone.vue?vue&type=template&id=f800e904&"
import script from "./file-dropzone.vue?vue&type=script&lang=ts&"
export * from "./file-dropzone.vue?vue&type=script&lang=ts&"
import style0 from "./file-dropzone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports